exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transition__slide_vertical-enter-active,.transition__slide_vertical-leave-active{transition:top .5s ease-in-out}.transition__slide_vertical-enter,.transition__slide_vertical-leave-to{top:-100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08e53e8f","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/transition/SlideVertical.vue
// module id = a04f63342dc56f521233
// module chunks = 0